<div class="flex w-full flex-col">
  <div
    class="flex flex-col rounded-t-2xl border-t border-r border-l p-6 pb-4"
    [ngStyle]="{
      borderColor: corporateDesign.primaryBorderColor(),
      backgroundColor: corporateDesign.surface1(),
      color: corporateDesign.isDarkModeActive()
        ? corporateDesign.corporateDesign().primaryDarkFontColor
        : corporateDesign.corporateDesign().colorAdmixtures.standard_text_high,
    }">
    <h2 class="my-3 text-center text-3xl font-bold">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.ticketSelection
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </h2>
    @if (showReservationDeadline() && reservationDeadline()) {
      <p
        class="mt-2 text-center text-base font-semibold"
        [ngStyle]="{
          color: corporateDesign.isDarkModeActive()
            ? corporateDesign.corporateDesign().colorAdmixtures.error_red_dark
            : corporateDesign.corporateDesign().colorAdmixtures.error_red,
        }">
        {{
          (
            textStore.texts()
            | filterTexts
              : ERelationType.reservedUntil
              : EEntityType.onDemandTicketConfiguration
            | language
          )?.replace('X', reservationDeadline() ?? '')
        }}
      </p>
    }
  </div>

  @for (
    passenger of selectionState.passengerTicketSelections();
    track $index;
    let pIdx = $index
  ) {
    <div
      class="relative flex h-10 items-center overflow-hidden"
      [ngStyle]="{ backgroundColor: corporateDesign.surface1() }">
      <div
        class="absolute top-1/2 left-0 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full border border-l-0"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
          backgroundColor: corporateDesign.surface1(),
        }"></div>
      <div
        class="mx-5 flex-1 border-t-2 border-dashed"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
        }"></div>
      <div
        class="absolute top-1/2 right-0 h-10 w-10 translate-x-1/2 -translate-y-1/2 rounded-full border border-r-0"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
          backgroundColor: corporateDesign.surface1(),
        }"></div>
    </div>

    <div
      class="border-r border-l"
      [ngStyle]="{
        borderColor: corporateDesign.primaryBorderColor(),
        backgroundColor: corporateDesign.surface1(),
        color: corporateDesign.isDarkModeActive()
          ? corporateDesign.corporateDesign().primaryDarkFontColor
          : corporateDesign.corporateDesign().colorAdmixtures
              .standard_text_high,
      }">
      <button
        type="button"
        class="flex w-full flex-row items-center justify-between px-6 py-4 text-left"
        (click)="togglePassengerExpanded(pIdx)">
        <div class="flex items-center gap-2">
          <span class="material-symbols-rounded opacity-60">person</span>
          <span class="text-base font-bold"
            >{{
              textStore.texts()
                | filterTexts
                  : ERelationType.onDemandPassenger
                  : EEntityType.onDemandTicketConfiguration
                | language
            }}
            {{ pIdx + 1 }}</span
          >
          <span class="text-sm opacity-60">({{ passenger.fahrgasttyp }})</span>
        </div>
        <span class="material-symbols-rounded opacity-60">
          {{ expandedStates()[pIdx] ? 'expand_less' : 'expand_more' }}
        </span>
      </button>

      @if (expandedStates()[pIdx]) {
        <div class="mx-4 mb-4 flex flex-col gap-3">
          <div
            class="flex flex-wrap gap-2 rounded-xl border p-4"
            [ngStyle]="{ borderColor: corporateDesign.primaryBorderColor() }">
            @if (tripDate()) {
              <span
                class="flex items-center gap-1 rounded-xl border px-3 py-1.5 text-sm font-medium"
                [ngStyle]="{
                  borderColor: corporateDesign.primaryBorderColor(),
                  backgroundColor: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().colorAdmixtures
                        .dark_surface_03
                    : corporateDesign.surface1(),
                  color: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().primaryDarkFontColor
                    : corporateDesign.corporateDesign().colorAdmixtures
                        .standard_text_high,
                }">
                <span class="material-symbols-rounded text-base opacity-60"
                  >calendar_today</span
                >
                {{ tripDate() | date: 'dd.MM.yyyy' }}
              </span>
            }
            <span
              class="flex items-center gap-1 rounded-xl border px-3 py-1.5 text-sm font-medium"
              [ngStyle]="{
                borderColor: corporateDesign.primaryBorderColor(),
                backgroundColor: corporateDesign.isDarkModeActive()
                  ? corporateDesign.corporateDesign().colorAdmixtures
                      .dark_surface_03
                  : corporateDesign.surface1(),
                color: corporateDesign.isDarkModeActive()
                  ? corporateDesign.corporateDesign().primaryDarkFontColor
                  : corporateDesign.corporateDesign().colorAdmixtures
                      .standard_text_high,
              }">
              <span class="material-symbols-rounded text-base opacity-60"
                >person</span
              >
              {{ passenger.fahrgasttyp }}
            </span>
            @for (entry of getExtraEntries(pIdx); track entry.label) {
              <span
                class="flex items-center gap-1 rounded-xl border px-3 py-1.5 text-sm font-medium"
                [ngStyle]="{
                  borderColor: corporateDesign.primaryBorderColor(),
                  backgroundColor: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().colorAdmixtures
                        .dark_surface_03
                    : corporateDesign.surface1(),
                  color: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().primaryDarkFontColor
                    : corporateDesign.corporateDesign().colorAdmixtures
                        .standard_text_high,
                }">
                <span class="material-symbols-rounded text-base opacity-60"
                  >check</span
                >
                @if (entry.count > 1) {
                  {{ entry.count }}x
                }
                {{ entry.label }}
              </span>
            }
          </div>

          <div
            class="overflow-hidden rounded-xl border"
            [ngStyle]="{
              borderColor: corporateDesign.primaryBorderColor(),
              backgroundColor: corporateDesign.surface1(),
              color: corporateDesign.isDarkModeActive()
                ? corporateDesign.corporateDesign().primaryDarkFontColor
                : corporateDesign.corporateDesign().colorAdmixtures
                    .standard_text_high,
            }">
            <div
              class="grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-1 p-4">
              @if (passenger.useExistingTicket) {
                <h4
                  class="col-start-1 row-start-1 text-sm font-bold line-through opacity-30">
                  {{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.onDemandTicket
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}
                </h4>
              } @else {
                <h4 class="col-start-1 row-start-1 font-bold">
                  {{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.onDemandTicket
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}
                </h4>
              }

              <p class="col-span-2 col-start-1 row-start-2 text-xs opacity-60">
                {{ astOrigin() }} – {{ astDestination() }}
              </p>

              <div class="col-start-1 row-start-3 my-4">
                <span
                  class="rounded-xl px-3 py-2.5 text-sm font-semibold"
                  [ngStyle]="{
                    backgroundColor: corporateDesign.primaryColor(),
                    color:
                      corporateDesign.corporateDesign().primaryDarkFontColor,
                  }">
                  {{ onDemandTransportName() }}
                </span>
              </div>

              <span
                class="col-start-2 row-start-3 my-4 self-end font-bold whitespace-nowrap"
                [class.text-sm]="passenger.useExistingTicket"
                [class.line-through]="passenger.useExistingTicket"
                [class.opacity-30]="passenger.useExistingTicket">
                {{ getOnDemandSinglePriceLabel(passenger.fahrgasttyp) }}
              </span>
            </div>

            @if (passenger.useExistingTicket) {
              <div class="px-4 py-3">
                <div
                  class="mb-2 flex items-start gap-2.5 rounded-xl border p-3"
                  [ngStyle]="{
                    borderColor:
                      corporateDesign.corporateDesign().colorAdmixtures
                        .standard_success,
                    backgroundColor:
                      corporateDesign.corporateDesign().colorAdmixtures
                        .standard_success +
                      (corporateDesign.isDarkModeActive() ? '25' : '15'),
                    color:
                      corporateDesign.corporateDesign().colorAdmixtures
                        .standard_success,
                  }">
                  <span class="material-symbols-rounded mt-0.5"
                    >confirmation_number</span
                  >
                  <div>
                    <p class="text-sm font-bold">
                      {{
                        textStore.texts()
                          | filterTexts
                            : ERelationType.existingTicketActive
                            : EEntityType.onDemandTicketConfiguration
                          | language
                      }}
                    </p>
                    <p class="text-base font-medium">
                      {{ passenger.existingTicketType }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="border-t px-4 py-3"
                [ngStyle]="{
                  borderColor: corporateDesign.primaryBorderColor(),
                }">
                <div class="flex items-start justify-between">
                  <div>
                    <h4 class="text-base font-bold">
                      {{
                        textStore.texts()
                          | filterTexts
                            : ERelationType.comfortSurchargeLabel
                            : EEntityType.onDemandTicketConfiguration
                          | language
                      }}
                    </h4>
                    <p class="text-xs opacity-60">
                      {{
                        textStore.texts()
                          | filterTexts
                            : ERelationType.comfortSurchargeExistingTicket
                            : EEntityType.onDemandTicketConfiguration
                          | language
                      }}
                    </p>
                  </div>
                  <span class="font-bold">
                    {{ getComfortSinglePriceLabel(passenger.fahrgasttyp) }}
                  </span>
                </div>
              </div>
            } @else if (showPublicTransport()) {
              <div
                class="grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-1 border-t p-4"
                [ngStyle]="{
                  borderColor: corporateDesign.primaryBorderColor(),
                }">
                <h4 class="col-start-1 row-start-1 font-bold">
                  {{
                    pricingStore.getPublicTransportTicketLabel(
                      passenger.fahrgasttyp
                    )
                  }}
                </h4>

                <p
                  class="col-span-2 col-start-1 row-start-2 text-xs opacity-60">
                  {{ regularLeg()?.origin?.name }} –
                  {{ regularDestination()?.name }}
                </p>

                @if (regularTransportNames().length) {
                  <div
                    class="col-start-1 row-start-3 my-4 flex flex-wrap gap-2">
                    @for (
                      transportName of regularTransportNames();
                      track transportName
                    ) {
                      <span
                        class="rounded-xl border px-3 py-2.5 text-sm font-semibold"
                        [ngStyle]="{
                          borderColor: corporateDesign.primaryBorderColor(),
                        }">
                        {{ transportName }}
                      </span>
                    }
                  </div>
                }

                <span
                  class="col-start-2 row-start-3 my-4 self-end font-bold whitespace-nowrap">
                  {{
                    pricingStore.getPassengerSinglePriceLabel(
                      passenger.fahrgasttyp
                    )
                  }}
                </span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <div
    class="relative flex h-10 items-center overflow-hidden"
    [ngStyle]="{ backgroundColor: corporateDesign.surface1() }">
    <div
      class="absolute top-1/2 left-0 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full border border-l-0"
      [ngStyle]="{
        borderColor: corporateDesign.primaryBorderColor(),
        backgroundColor: corporateDesign.surface1(),
      }"></div>
    <div
      class="mx-5 flex-1 border-t-2 border-dashed"
      [ngStyle]="{ borderColor: corporateDesign.primaryBorderColor() }"></div>
    <div
      class="absolute top-1/2 right-0 h-10 w-10 translate-x-1/2 -translate-y-1/2 rounded-full border border-r-0"
      [ngStyle]="{
        borderColor: corporateDesign.primaryBorderColor(),
        backgroundColor: corporateDesign.surface1(),
      }"></div>
  </div>

  <div
    class="rounded-b-2xl border-r border-b border-l p-6 pt-4"
    [ngStyle]="{
      borderColor: corporateDesign.primaryBorderColor(),
      backgroundColor: corporateDesign.surface1(),
      color: corporateDesign.isDarkModeActive()
        ? corporateDesign.corporateDesign().primaryDarkFontColor
        : corporateDesign.corporateDesign().colorAdmixtures.standard_text_high,
    }">
    <div
      class="flex flex-row items-center justify-between pb-4 text-xl font-bold">
      <span>{{
        textStore.texts()
          | filterTexts
            : ERelationType.totalAmount
            : EEntityType.onDemandTicketConfiguration
          | language
      }}</span>
      <span class="text-2xl">{{ pricingStore.totalAmountLabel() }}</span>
    </div>
    <ng-content select="[summary-action]" />
  </div>
</div>
